module.exports = __webpack_public_path__ + "img/322.6d74d906.png";